import cookies from './cookies';

const tracking = __CLIENT__
  ? (() => {
      const host = global.location.host;
      const __PRODUCTION__ = /(www|en)\.boligninja\.dk/.test(host);

      if (global.location.hostname === 'localhost') {
        return {
          prepare() {},
          conversion() {},
          goal() {},
          event() {},
          page() {},
          error() {},
          action() {}
        };
      }

      const win = global;
      const doc = document;
      const tag = 'script';

      function pixels(name, value, opts = {}) {
        try {
          const cookie = cookies.getItem('bn.utm');
          if (cookie) {
            const utm = JSON.parse(cookie);
            if (utm.source === 'akutbolig') {
              if (/^tenantad-/.test(name)) {
                var img = doc.createElement('img');
                img.src = `${
                  __PRODUCTION__ ? 'https://www.akutbolig.dk' : `http://${host}`
                }/t/l/bn0/${(opts.ref && opts.ref.replace('sub_', '')) ||
                  '0'}.gif`;
                img.setAttribute('height', '1');
                img.setAttribute('width', '1');
                doc.body.appendChild(img);
              }
            }
          }
        } catch (err) {
          if (__DEV__) {
            console.error(err);
          }
        }
      }

      // Clicky
      // ------------------------------
      // function clickyGoal(name, revenue) {
      //   const clicky = win.clicky;
      //   if (clicky && clicky.goal) {
      //     clicky.goal(name, revenue);
      //   } else {
      //     const goal = revenue ? { name, revenue } : { name };
      //     win.clicky_custom = win.clicky_custom || {};
      //     win.clicky_custom.goal = goal;
      //   }
      // }

      // function clickyEvent(href = '#', title = '', type = 'click') {
      //   const clicky = win.clicky;
      //   if (clicky && typeof clicky.log === 'function') {
      //     clicky.log(href, title, type);
      //   }
      // }

      // Google Analytics + Adwords
      // ------------------------------
      function gaEvent(category, action, label, value) {
        if (typeof win.ga === 'function') {
          win.ga('send', 'event', category, action, label || '', value || 0);
        }
      }

      function adwordsConversionScript(win, doc, tag, src) {
        var ref = doc.getElementsByTagName(tag)[0];
        var el = doc.createElement(tag);
        el.async = 1;
        el.src = src;
        ref.parentNode.insertBefore(el, ref);
      }

      function adwordsConversionTracking() {
        if (!win.google_trackConversion || !__PRODUCTION__) {
          return;
        }
        /*
    win.google_conversion_id = 961042177;
    win.google_conversion_language = 'da';
    win.google_conversion_format = '3';
    win.google_conversion_color = 'ffffff';
    win.google_conversion_label = 'cNMZCLmSgFgQga6hygM';
    win.google_remarketing_only = false;
    var ref = doc.getElementsByTagName(tag)[0];
    var el = doc.createElement(tag);
    el.async = 1;
    el.src = src;
    ref.parentNode.insertBefore(el, ref);
  */
        win.google_trackConversion({
          google_conversion_id: 961042177,
          google_conversion_language: 'da',
          google_conversion_format: '3',
          google_conversion_color: 'ffffff',
          google_conversion_label: 'cNMZCLmSgFgQga6hygM',
          google_remarketing_only: false
        });
      }

      // ignore eslint
      // function bingConversionTracking (w,d,t,r,u) {
      //   var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:'4007577'};o.q=w[u],w[u]=new win.UET(o),w[u].push('pageLoad')},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=='loaded'&&s!=='complete'||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i);
      // }

      const methods = {
        prepare() {
          // Insert Async Adwords conversion tracking script
          adwordsConversionScript(
            win,
            doc,
            tag,
            '//www.googleadservices.com/pagead/conversion_async.js'
          );

          // TODO: Ensure Clicky is loaded
        },
        conversion(name, value, options) {
          // Analytics
          gaEvent('subscriptions', 'signup', name || '', value || 0);

          // Clicky
          // clickyGoal(name, value);

          adwordsConversionTracking();
          // bingConversionTracking(win, doc, tag, '//bat.bing.com/bat.js', 'uetq');

          // Perfect Audience
          // win._pq = win._pq || [];
          // win._pq.push(['track', 'allekoeb']);

          pixels(name, value, options);
        },
        goal(name, value) {
          // clickyGoal(name, value);
        },
        event(category, action, label, value) {
          gaEvent(category, action, label || '', value || 0);
          // clickyEvent(
          //   `#${category}/${action}`,
          //   value ? `${label}(${value})` : label
          // );
        },
        page(href, title) {
          // Used as a way to trigger pseudo-pageview manually (app/profile/subscription)
          // clickyEvent(href, title, 'pageview');
        },
        error(action, label, value) {
          gaEvent('errors', action, label || '', value || 0);
        },
        action(name) {
          if (name === 'user-signup') {
            methods.goal('user-signup');
            methods.event('users', 'signup');
          } else if (name === 'boligagent-signup') {
            methods.goal('boligagent-signup');
            methods.event('boligagent', 'signup');
          }
        }
      };

      return methods;
    })()
  : {
      prepare() {},
      conversion() {},
      goal() {},
      event() {},
      page() {},
      error() {},
      action() {}
    };

export default tracking;
